export default __webpack_public_path__ + "static/media/add-bank.a40de5aa.svg";